import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/spremna';
const recap = ['6 томова', '5 бонуса', '240 страна', '1–8. разред'];
const reassurances = ['Тренутни дигитални приступ', 'PDF спреман за штампу', '7 дана гаранције задовољства'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-109" data-mp="15fggqhcwiwzc">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-110" data-mp="1jb22mfnu90nj" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-111" data-mp="1t2yaujjn275h">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-112" data-mp="1t252xf8y1blr">
          Ваша математика може бити <em className="text-red-700" data-id="element-113" data-mp="223mjeyq9jfaz">спремна већ данас.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-114" data-mp="221jt0dl77k5q">
          Уместо да тражите идеје, сами правите сваки листић и недељом увече планирате, имате готов
          пакет за целу школску годину. Више времена за оно што је заиста важно:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-115" data-mp="s57fd5g43ssb">
          Ваши ученици. Ваша настава. Ваш живот ван школе.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-116" data-mp="12353lsxz1pkx">
          {recap.map(item => <li key={item} data-id="element-117" data-mp="1646thj600pa8">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-118" data-mp="1b31lnbpuvq70">Пре <s data-id="element-119" data-mp="1b1qkljnsowjl">{PRICE_BEFORE}</s></p>
        <p className="mt-2 whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-120" data-mp="1fu9uo6n9x9jn">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-121" data-mp="1ksbewuwfrewp">Једнократно плаћање – без претплате.</p>

        <div className="mt-8 flex justify-center" data-id="element-122" data-mp="1pt8xv9p9scz9">
          <CtaButton className="w-full sm:w-auto" data-id="element-123" data-mp="1pqd0pnl8xsbv" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-124" data-mp="1tuugzcsednhw">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-125" data-mp="3qskqy5xqtilf">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-126" data-mp="3lwvpfx25xrmh" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}